export default __webpack_public_path__ + "static/media/cycle_right_bk.e89d0e8a.png";